
import React, { useEffect, useState } from 'react'
import { Grid, Menu, Button, Dropdown, Icon, Ref, Sticky, Container } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import LogoIcon from "../../../../../assets/icons/Logo"
import { useDispatch, useSelector } from "react-redux";
import { ChangeActiveTab, SetShowSearchBox } from "../../../../../redux/actions/mainActions"
import "./NavigationBar.css"
import LanguageHandler from '../../../components/LanguageHandler/LanguageHandler';

const NavigationBar = ({ }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const isRtl = useSelector((state) => state.main.isRtl)
    const handleScroll = () => {
        dispatch(SetShowSearchBox(false))

    }
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, [])

    const trigger = (
        <span>
            <Icon circular name="user circle" />
        </span>

    )
    return <Menu fixed="top" secondary={true}
        className='SearchNav bg-white p-0 m-0 justify-content-center'
    >
        <Container fluid>
        <Grid verticalAlign='middle' columns='equal' className="w-100 m-0">
                <Grid.Row className="p-0">
                    
                <Grid.Column>
                        <Menu.Item className="justify-content-center" position={isRtl ? 'right' : 'left'}>
                        <LogoIcon className="icon-2rem  p-1" color='var(--main-red)' />
                    </Menu.Item>
                    </Grid.Column>
                    <Grid.Column>
                    </Grid.Column>


                    <Grid.Column>
                        <Menu.Item className="justify-content-center" position={isRtl ? 'left' : 'right'}>
                        <LanguageHandler />

                        <Button className="m-05" basic>Become a Host</Button>
                        <Dropdown
                            icon="bars"
                            trigger={trigger}
                            button
                            className='p-4px bg-white d-flex flex-row align-items-center'
                        >
                            <Dropdown.Menu right >
                                <Dropdown.Item>Sign Up</Dropdown.Item>
                                <Dropdown.Item>Log In</Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item>Host your home</Dropdown.Item>
                                <Dropdown.Item>Host an experience</Dropdown.Item>
                                <Dropdown.Item>Help</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Item>
                    </Grid.Column>

                </Grid.Row>

            </Grid>
        </Container>


    </Menu>
}
export default NavigationBar